import { Component, Input, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { Observable } from 'rxjs';
import { resumeDataInterface } from '../../interfaces/resume';

@Component({
  selector: 'mcrit-gestio-invoices-resume',
  templateUrl: 'invoices.resume.component.html',
  styleUrls: ['invoices.resume.component.css']
})
export class InvoicesResumeComponent implements OnInit {
  @Input() dades: resumeDataInterface;

  constructor(public translate: TranslateService, public languageService: LanguageService){}

  ngOnInit(){}
}
